import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule, isDevMode } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenubarModule } from 'primeng/menubar';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { DatePicker } from 'primeng/datepicker';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { EkoGenericTableComponent } from '@ekowitryna/ui';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { SkeletonModule } from 'primeng/skeleton';
import { HeaderTitleComponent } from './components/header-title/header-title.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ChipModule } from 'primeng/chip';
import { TooltipModule } from 'primeng/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { JoinToStringPipe } from './pipes/join-to-string/join-to-string.pipe';
import { CreateCompanyInstructionsComponent } from './components/create-company-instructions/create-company-instructions.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { CompanyDataRequiredComponent } from './components/company-data-required/company-data-required.component';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        HeaderTitleComponent,
        CreateCompanyInstructionsComponent,
        AccessDeniedComponent,
        CompanyDataRequiredComponent,
        JoinToStringPipe
    ],
    exports: [
        HeaderTitleComponent,
        JoinToStringPipe,
        CreateCompanyInstructionsComponent,
        AccessDeniedComponent,
        CompanyDataRequiredComponent
    ], imports: [
        CommonModule,
        FormsModule,
        MenubarModule,
        AvatarModule,
        ButtonModule,
        MenuModule,
        DatePicker,
        InputNumberModule,
        InputTextModule,
        Select,
        ProgressSpinnerModule,
        EkoGenericTableComponent,
        DynamicDialogModule,
        TranslateModule,
        SkeletonModule,
        ReactiveFormsModule,
        TooltipModule,
        ChipModule,
        FontAwesomeModule,
        ConfirmDialogModule
        ],
         providers: [provideHttpClient(withInterceptorsFromDi())] })
export class SharedModule { }
